// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scl--submit-main-content{
    padding: 10px 130px;
    max-width: 1920px;
    width: 100%;
}

.scl--crr-smb-head-const-box{
    width: 100%;
}

.scl--crr-smb-filt-const-box {
  width: 100%;
  display: flex;
  align-items: center; /* add this */
  gap: 15px;
  padding-top: 15px;
}

.scl--crr-smb-filt-deparment{
    min-width: 133px;
}

.scl--crr-smb-filt-status{
    min-width: 100px;
}

.scl--crr-smb-filt-type{
    min-width: 100px;
}

.scl--crr-smb-filt-search{
    width: 279px;
}

.scl--crr-smb-tabl-const-box{
    margin-top: 10px;
    padding-bottom: 60px;
}

.scl--crr-smb-tabl-const-box .scl--components-table-dynamicTable-main thead th{
    padding-left: 0px;
}



.scl--crr-smb-tabl-const-box .scl--components-table-dynamicTable-main tbody td::first-letter{
    text-transform: uppercase;
}

.scl--crr-smb-tabl-const-box .scl--components-table-dynamicTable-main tbody td:nth-child(2), .scl--ibx-tabl-const-box .scl--components-table-dynamicTable-main tbody td:nth-child(4), .scl--ibx-tabl-const-box .scl--components-table-dynamicTable-main tbody td:nth-child(5), .scl--ibx-tabl-const-box .scl--components-table-dynamicTable-main tbody td:nth-child(6){
    color: var(--typography-text-body-secondary);
}
.scl--crr-smb-tabl-const-box .scl--components-table-dynamicTable-main tbody td {
  max-width: 0; /* this is the key — forces fixed layout to actually clip */
      padding-left: 0px;
}

.scl--crr-smb-tabl-const-box .scl--components-table-dynamicTable-clickable-cell {
  width: 100%;
  overflow: hidden;
    text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block; /* change from inline-flex to block */
}`, "",{"version":3,"sources":["webpack://./src/page-controller-mod/page-serv/career/css/submit.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB,EAAE,aAAa;EAClC,SAAS;EACT,iBAAiB;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;AACrB;;;;AAIA;IACI,yBAAyB;AAC7B;;AAEA;IACI,4CAA4C;AAChD;AACA;EACE,YAAY,EAAE,2DAA2D;MACrE,iBAAiB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;IACd,gBAAgB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc,EAAE,qCAAqC;AACvD","sourcesContent":[".scl--submit-main-content{\n    padding: 10px 130px;\n    max-width: 1920px;\n    width: 100%;\n}\n\n.scl--crr-smb-head-const-box{\n    width: 100%;\n}\n\n.scl--crr-smb-filt-const-box {\n  width: 100%;\n  display: flex;\n  align-items: center; /* add this */\n  gap: 15px;\n  padding-top: 15px;\n}\n\n.scl--crr-smb-filt-deparment{\n    min-width: 133px;\n}\n\n.scl--crr-smb-filt-status{\n    min-width: 100px;\n}\n\n.scl--crr-smb-filt-type{\n    min-width: 100px;\n}\n\n.scl--crr-smb-filt-search{\n    width: 279px;\n}\n\n.scl--crr-smb-tabl-const-box{\n    margin-top: 10px;\n    padding-bottom: 60px;\n}\n\n.scl--crr-smb-tabl-const-box .scl--components-table-dynamicTable-main thead th{\n    padding-left: 0px;\n}\n\n\n\n.scl--crr-smb-tabl-const-box .scl--components-table-dynamicTable-main tbody td::first-letter{\n    text-transform: uppercase;\n}\n\n.scl--crr-smb-tabl-const-box .scl--components-table-dynamicTable-main tbody td:nth-child(2), .scl--ibx-tabl-const-box .scl--components-table-dynamicTable-main tbody td:nth-child(4), .scl--ibx-tabl-const-box .scl--components-table-dynamicTable-main tbody td:nth-child(5), .scl--ibx-tabl-const-box .scl--components-table-dynamicTable-main tbody td:nth-child(6){\n    color: var(--typography-text-body-secondary);\n}\n.scl--crr-smb-tabl-const-box .scl--components-table-dynamicTable-main tbody td {\n  max-width: 0; /* this is the key — forces fixed layout to actually clip */\n      padding-left: 0px;\n}\n\n.scl--crr-smb-tabl-const-box .scl--components-table-dynamicTable-clickable-cell {\n  width: 100%;\n  overflow: hidden;\n    text-align: left;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: block; /* change from inline-flex to block */\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
